
/**
 * @ngdoc directive
 * @name universepanel
 *
 * @description
 * Universe panel
 */
module.directive('universepanel', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '='
        },
        template:
            '<div class="aqua-universepanel grid-main is-hidden-m" ng-style="{\'background-color\': content.field_theme_universe.color_background}">' +
            '  <a ng-attr-name="{{content.nid}}"></a>' +
            '  <ul ng-if="content.field_slides.length > 0" class="aqua-universepanel--items grid grid-b2c-gutter">' +
            '    <li ng-repeat="category in content.field_slides" class="aqua-universepanel--item grid-3 grid-6-m">' +
            '      <a class="aqua-universepanel--item-link grid grid-v aqua-content-block" ng-href="{{category.url}}" >' +
            '       <picture class="aqua-content-img-back">' +
            '           <source media="(min-width: 960px)" srcset="{{ category.styles.w232h400 }}">' +
            '           <source media="(max-width: 959px)" srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==">' +
            '           <img src="{{ category.src }}" loading="lazy">' +
            '       </picture>' +
            '        <div class="aqua-universepanel--content grid grid-v grid-center grid-middle aqua-content-img-front">' +
            '          <h2 class="aqua-universepanel--title" ng-style="{\'color\': content.field_theme_universe.color_title}">{{category.title}}</h2>' +
            '          <span class="aqua-universepanel--text" ng-style="{\'color\': content.field_theme_universe.color_subtitle}">{{category.alt}}</span>' +
            '        </div>' +
            '      </a>' +
            '    </li>' +
            '  </ul>' +
            '  <div class="grid grid-center is-hidden-s" ng-if="content.field_url_acces_stage">' +
            '    <a class="aqua-universepanel--button" ng-href="{{content.field_url_acces_stage}}">{{content.field_titre_acces_stage}}</a>' +
            '  </div>' +
            '  <div class="grid grid-center is-hidden-s" ng-if="content.field_url_acces_entreprise">' +
            '    <a class="aqua-universepanel--link" ng-href="{{content.field_url_acces_entreprise}}">{{content.field_titre_acces_entreprise}}</a>' +
            '  </div>' +
            '</div>' +

            '<div class="aqua-universepanel is-visible-m" style="background: #ebebeb">' +
            '  <ul ng-if="content.field_slides.length > 0" class="grid">' +
            '    <li ng-repeat="category in content.field_slides" class="aqua-universepanel--item grid-6">' +
            '      <a class="aqua-universepanel--item-link grid grid-12" ng-href="{{category.url}}" style="background: white"> ' +
            '       <div class="grid-4 grid grid-center grid-middle">' +
            '           <picture class="aqua-universepanel-picto">' +
            '               <source media="(min-width: 959px)" srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==">' +
            '               <img src="{{ category.picto }}" />' +
            '           </picture>' +
            '       </div>' +
            '        <div class="grid-8 grid grid-center grid-middle grid-v">' +
            '           <div class="grid grid-center grid-12 grid-v aqua-universepanel-content">' +
            '               <h2 class="aqua-universepanel--title responsive" ng-style="{\'color\': content.field_theme_universe.color_title}">{{category.title}}</h2>' +
            '               <span class="aqua-universepanel--text" ng-style="{\'color\': content.field_theme_universe.color_subtitle}">{{category.alt}}</span>' +
            '           </div>' +
            '           <div class="grid-12 aqua-universepanel--go-block">' +
            '               <span class="aqua-universepanel--go-link"></span>' +
            '           </div>' +
            '        </div>' +
            '      </a>' +
            '    </li>' +
            '  </ul>' +
            '</div>'
    };
});
